import { CustomLink } from '@/components/custom-link/CustomLink';
import { useClientI18nModelStore } from '@/models/client-i18n/clientI18n';
import type { SidebarTreeNode } from '@/shared/constant/sidebar-tree/SidebarTreeNode';
import { FoxIconArrowNarrowLeft, FoxIconArrowNarrowRight } from 'aui-biz-icons';
import clsx from 'clsx';
import styles from './PaginatorItem.module.css';

export enum PaginatorItemPosition {
  Previous = 'previous',
  Next = 'next',
}

export type PaginatorItemProps = {
  value: SidebarTreeNode;
  position: PaginatorItemPosition;
  className?: string;
};

export function PaginatorItem(props: PaginatorItemProps) {
  const { className, value, position } = props;
  const clientI18n = useClientI18nModelStore((x) => x.clientI18n);

  return (
    <CustomLink
      className={clsx(
        'relative flex items-center gap-4 rounded-xl border border-color-split px-4 py-3 hover:shadow-sm',
        styles['paginator-item'],
        className,
      )}
      to={value.to}
    >
      {position === PaginatorItemPosition.Previous && (
        <FoxIconArrowNarrowLeft
          className={clsx(styles['paginator-item-icon'], styles['paginator-item-icon-left'])}
          size={24}
        />
      )}
      <div
        className={clsx('w-0 flex-1', {
          ['text-right']: position === PaginatorItemPosition.Previous,
        })}
      >
        <div className="mb-1 text-sm font-400 text-secondary">
          {clientI18n(position === PaginatorItemPosition.Previous ? 'previous' : 'next')}
        </div>
        <div className="truncate text-[16px] font-500 leading-6 text-color">{value.name}</div>
      </div>

      {position === PaginatorItemPosition.Next && (
        <FoxIconArrowNarrowRight
          className={clsx(styles['paginator-item-icon'], styles['paginator-item-icon-right'])}
          size={24}
        />
      )}
    </CustomLink>
  );
}
